import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";

import TextField from "@material-ui/core/TextField";
const useStyles = makeStyles((theme) => ({}));
function Minutes(props) {
  const [value, setValue] = useState(1);
  const classes = useStyles();
  const returnValue = (value) => {
    setValue(value);
    props.returnValue(value);
  };

  return (
    <div style={{ marginTop: 20 }}>
      <TextField
        id="outlined-number"
        label="Every minute(s)"
        value={value}
        min={1}
        max={60}
        onChange={(e) => {
          e.target.value < 60 &&
            e.target.value >= 1 &&
            returnValue(e.target.value);
        }}
        type="number"
        InputLabelProps={{
          shrink: true,
        }}
        margin="normal"
        variant="outlined"
      />
    </div>
  );
}

export default Minutes;
